import {Pill} from '@mantine/core';
import classes from './pill.module.css';

export const PillTheme = Pill.extend({
  classNames: {
    root: classes.root,
  },
});